/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespIconBubbles_item = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_item",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubblePinterest_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleFacebook_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_item",
      "args": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
